import type {DripSequenceStatus} from '../edition/get-edition-status-info';
// @ts-expect-error
import {PauseCircleIcon} from '../icon/svg/pause-circle-icon';
// @ts-expect-error - imported from .js/.jsx file
import {PlayButtonIcon} from '../icon/svg/play-button-icon';
// @ts-expect-error - imported from .js/.jsx file
import {StopCircleIcon} from '../icon/svg/stop-circle-icon';

export const getDripSequenceTriggerIcon = (status: DripSequenceStatus) => {
    let icon = StopCircleIcon;

    switch (status) {
        case 'ACTIVE':
            icon = PlayButtonIcon;
            break;
        case 'DRAFT':
            icon = PlayButtonIcon;
            break;
        case 'PAUSED':
            icon = PauseCircleIcon;
            break;
    }

    return icon;
};
